import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { paragraphStyle, payTableStyle } from './textStyle'
import { Image, t } from '@slot-nx/core'

export interface ParagraphProps {
  y: number
  width: number
  height: number
  stake?: number
}

export const Paragraph2 = (props: ParagraphProps) => {
  const contentIndentSize = 100
  const content = useMemo(() => {
    return (
      <Container
        y={props.y}
        name="paragraph2_title"
      >
        <Container
          x={props.width / 2}
        >
          <Image
            name="Bonus"
            image="Bonus"
            x={-150}
            y={0}
            anchor={0.5}
            width={200}
            height={200}
          />
          <Text
            x={-150}
            y={175}
            text={(t('gameRules_title1_content_6'))}
            anchor={[0.5, 1]}
            style={paragraphStyle}
          />
          <Image
            name="SuperBonus"
            image="SuperBonus"
            x={150}
            y={0}
            anchor={0.5}
            width={200}
            height={200}
          />
          <Text
            x={150}
            y={175}
            text={(t('gameRules_title1_content_7'))}
            anchor={[0.5, 1]}
            style={paragraphStyle}
          />
        </Container>

        <Text
          x={contentIndentSize}
          y={250}
          text={(t('gameRules_title1_content_3'))}
          style={payTableStyle}
        />

        <Text
          x={contentIndentSize}
          y={300}
          text={(t('gameRules_title1_content_4'))}

          style={payTableStyle}
        />
      </Container>
    )
  }
  , [])
  return content
}
